import React from 'react'
import { CreateEditOrganization } from '../../shared'

const CreateOrganization = () => {
    return (
        <CreateEditOrganization />
    )
}

export default CreateOrganization